/* Chithira Maadam theme — minimal, no framework */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- Mega menu ---- */
  var mega = $('#mega');
  $$('[data-mega-open]').forEach(function (b) {
    b.addEventListener('click', function () { mega.setAttribute('open', ''); b.setAttribute('aria-expanded', 'true'); });
  });
  $$('[data-mega-close]').forEach(function (b) {
    b.addEventListener('click', function () { mega.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mega) mega.removeAttribute('open'); });

  /* ---- Facets: auto-submit on change, keep sort + page params ---- */
  var form = $('[data-facets]');
  if (form) {
    form.addEventListener('change', function (e) {
      if (e.target.type === 'checkbox') submitFacets();
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submitFacets(); });
  }
  function submitFacets() {
    var params = new URLSearchParams();
    $$('input,select', form).forEach(function (el) {
      if (el.type === 'checkbox') { if (el.checked) params.append(el.name, el.value); }
      else if (el.value) { params.append(el.name, el.value); }
    });
    var sort = $('[data-sort]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    location.search = params.toString();
  }
  var clear = $('[data-clear-facets]');
  if (clear) clear.addEventListener('click', function () { location.search = ''; });

  /* ---- Sort ---- */
  var sortSel = $('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var p = new URLSearchParams(location.search);
    p.set('sort_by', sortSel.value);
    p.delete('page');
    location.search = p.toString();
  });

  /* ---- Mobile filter drawer ---- */
  var ft = $('[data-facet-toggle]');
  if (ft) ft.addEventListener('click', function () { form.classList.toggle('is-open'); });

  /* ---- Product gallery ---- */
  var hero = $('#pdp-hero');
  $$('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var img = $('img', b);
      if (!hero || !img) return;
      hero.src = img.src.replace(/width=\d+/, 'width=1000').replace(/_120x/, '_1000x');
      $$('[data-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
      b.setAttribute('aria-current', 'true');
    });
  });

  /* ---- Quick add from card ---- */
  $$('[data-quick-add]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var id = b.getAttribute('data-quick-add');
      b.textContent = '…'; b.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          $('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); });
          b.textContent = '✓';
          setTimeout(function () { b.textContent = '+'; b.disabled = false; }, 1200);
        })
        .catch(function () { b.textContent = '+'; b.disabled = false; });
    });
  });

  /* ---- Buy now goes straight to checkout ---- */
  $$('[data-add-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name === 'checkout') {
        f.action = '/cart/add';
        var h = document.createElement('input');
        h.type = 'hidden'; h.name = 'return_to'; h.value = '/checkout';
        f.appendChild(h);
      }
    });
  });
})();


/* ================= Premium UX v2 — theme toggle, reveal, mobile tab bar ================= */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- Scroll reveal ---- */
  var revealTargets = $$('.rowsec, .tiles, .foot__cols');
  if ('IntersectionObserver' in window && revealTargets.length) {
    revealTargets.forEach(function (el) { el.classList.add('reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealTargets.forEach(function (el) { io.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('reveal', 'is-visible'); });
  }

  /* ---- Mobile tab bar: search shortcut ---- */
  $$('[data-mobiletab-search]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function () {
        var input = $('.srch__in');
        if (input) input.focus();
      }, 350);
    });
  });

  /* ---- Mobile tab bar: active state by path ---- */
  var path = window.location.pathname;
  $$('.mobiletab__item[href]').forEach(function (a) {
    var href = a.getAttribute('href');
    if (href === '/' ? path === '/' : path.indexOf(href) === 0) {
      a.classList.add('is-active');
    }
  });
})();

/* ---- Language suggestion prompt (v9) ---- */
(function () {
  var cfg = window.CM_I18N;
  var box = document.getElementById("langprompt");
  if (!cfg || !box || !cfg.available || cfg.available.length < 2) return;

  var KEY = "cm-lang-choice";
  try { if (localStorage.getItem(KEY)) return; } catch (e) {}

  /* prompt copy, written in each language so it reads native */
  var COPY = {
    ta: { q: "தமிழில் பார்க்கவா?", y: "ஆம்" },
    hi: { q: "हिन्दी में देखें?", y: "हाँ" },
    ml: { q: "മലയാളത്തിൽ കാണണോ?", y: "അതെ" },
    te: { q: "తెలుగులో చూడాలా?", y: "అవును" },
    kn: { q: "ಕನ್ನಡದಲ್ಲಿ ನೋಡಬೇಕೇ?", y: "ಹೌದು" },
    mr: { q: "मराठीत पाहायचे?", y: "होय" },
    fr: { q: "Voir en français ?", y: "Oui" },
    de: { q: "Auf Deutsch ansehen?", y: "Ja" },
    es: { q: "¿Ver en español?", y: "Sí" }
  };

  function base(t) { return String(t || "").toLowerCase().split("-")[0]; }

  /* what the visitor prefers, from their browser */
  var prefs = (navigator.languages && navigator.languages.length)
    ? navigator.languages.slice()
    : [navigator.language || ""];

  var isoList = cfg.available.map(function (l) { return l.iso; });
  var match = null;
  for (var i = 0; i < prefs.length && !match; i++) {
    var p = base(prefs[i]);
    for (var j = 0; j < isoList.length; j++) {
      if (base(isoList[j]) === p) { match = cfg.available[j]; break; }
    }
  }

  /* already viewing it, or nothing matched -> stay quiet */
  if (!match || base(match.iso) === base(cfg.current)) return;

  var copy = COPY[base(match.iso)];
  var qText = copy ? copy.q : "View in " + match.name + "?";
  var yText = copy ? copy.y : "View in " + match.name;

  document.getElementById("langprompt-txt").textContent = qText;
  var yes = document.getElementById("langprompt-yes");
  yes.textContent = yText;
  box.hidden = false;
  requestAnimationFrame(function () { box.classList.add("is-in"); });

  function remember(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function close() { box.classList.remove("is-in"); setTimeout(function () { box.hidden = true; }, 260); }

  yes.addEventListener("click", function () {
    remember(match.iso);
    document.getElementById("langprompt-code").value = match.iso;
    document.getElementById("langprompt-form").submit();
  });
  document.getElementById("langprompt-no").addEventListener("click", function () {
    remember(cfg.current); close();
  });
  document.getElementById("langprompt-x").addEventListener("click", function () {
    remember(cfg.current); close();
  });

  /* a manual pick from the header switcher counts as a decision too */
  var sel = document.getElementById("langsw-select");
  if (sel) sel.addEventListener("change", function () { remember(sel.value); });
})();


/* ===== CM_WISHLIST — saved pieces, kept in this browser ===== */
(function(){
  var KEY='cm_wishlist_v1';
  function read(){ try{ var r=localStorage.getItem(KEY); var a=r?JSON.parse(r):[]; return Array.isArray(a)?a:[]; }catch(e){ return []; } }
  function write(a){ try{ localStorage.setItem(KEY, JSON.stringify(a)); }catch(e){} }
  function money(v){
    var n=Number(v); if(isNaN(n)) return '';
    return '\u20B9' + n.toLocaleString('en-IN', {maximumFractionDigits:0});
  }
  function paint(){
    var a=read();
    document.querySelectorAll('[data-wish]').forEach(function(b){
      var on = a.indexOf(String(b.getAttribute('data-wish')))>-1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on?'true':'false');
      b.setAttribute('aria-label', on?'Remove from saved pieces':'Save this piece');
    });
    document.querySelectorAll('[data-wish-count]').forEach(function(c){
      c.textContent = a.length ? String(a.length) : '';
    });
  }
  function toggle(id){
    id=String(id); var a=read(); var i=a.indexOf(id);
    if(i>-1){ a.splice(i,1); } else { a.push(id); }
    write(a); paint();
    if(i>-1){
      var card=document.querySelector('#wishlist-grid [data-pid="'+id+'"]');
      if(card){ card.remove(); checkEmpty(); }
    }
  }
  function checkEmpty(){
    var grid=document.getElementById('wishlist-grid');
    if(!grid) return;
    var any=grid.children.length>0;
    var wrap=document.getElementById('wishlist-wrap');
    var empty=document.getElementById('wishlist-empty');
    if(wrap) wrap.hidden=!any;
    if(empty) empty.hidden=any;
  }

  document.addEventListener('click', function(e){
    var b=e.target.closest && e.target.closest('[data-wish]');
    if(!b) return;
    e.preventDefault(); e.stopPropagation();
    toggle(b.getAttribute('data-wish'));
  });

  function renderPage(){
    var grid=document.getElementById('wishlist-grid');
    if(!grid) return;
    var loading=document.getElementById('wishlist-loading');
    var wrap=document.getElementById('wishlist-wrap');
    var empty=document.getElementById('wishlist-empty');
    var ids=read();
    if(!ids.length){ if(loading) loading.hidden=true; if(empty) empty.hidden=false; return; }
    fetch('/products.json?limit=250')
      .then(function(r){ return r.json(); })
      .then(function(j){
        var byId={}; (j.products||[]).forEach(function(p){ byId[String(p.id)]=p; });
        var frag=document.createDocumentFragment(), found=0;
        ids.forEach(function(id){
          var p=byId[String(id)]; if(!p) return;
          found++;
          var v=(p.variants&&p.variants[0])||{};
          var img=(p.images&&p.images[0]&&p.images[0].src)||'';
          var vt=(v.title&&v.title!=='Default Title')?v.title:'';
          var a=document.createElement('article');
          a.className='card';
          a.setAttribute('data-pid', p.id);
          a.innerHTML =
            '<button type="button" class="wish is-on" data-wish="'+p.id+'" aria-pressed="true" aria-label="Remove from saved pieces">'+
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5 4.3 13a4.7 4.7 0 0 1 6.6-6.7l1.1 1 1.1-1A4.7 4.7 0 0 1 19.7 13Z"/></svg></button>'+
            '<a class="card__media" href="/products/'+p.handle+'" tabindex="-1" aria-hidden="true">'+
            (img?'<img src="'+img+'" alt="" loading="lazy">':'')+'</a>'+
            '<div class="card__body">'+
            '<a class="card__title" href="/products/'+p.handle+'">'+String(p.title||'').replace(/[<>&]/g, function(m){return {'<':'&lt;','>':'&gt;','&':'&amp;'}[m];})+'</a>'+
            '<div class="card__price"><span class="price">'+money(v.price)+'</span></div>'+
            (vt?'<div class="card__meta">'+vt+'</div>':'')+
            '</div>';
          frag.appendChild(a);
        });
        grid.appendChild(frag);
        if(loading) loading.hidden=true;
        if(wrap) wrap.hidden=!found;
        if(empty) empty.hidden=!!found;
        paint();
      })
      .catch(function(){
        if(loading) loading.hidden=true;
        if(empty) empty.hidden=false;
      });
  }

  function bindClear(){
    var c=document.getElementById('wishlist-clear');
    if(!c) return;
    c.addEventListener('click', function(){
      write([]);
      var g=document.getElementById('wishlist-grid'); if(g) g.innerHTML='';
      checkEmpty(); paint();
    });
  }

  function boot(){ paint(); renderPage(); bindClear(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();


/* ===== CM_CSELECT — real custom dropdowns =====
   Wraps every <select> in a styled button + listbox. The native select stays in
   the form (visually hidden) so submission, validation and Shopify's own change
   listeners keep working exactly as before. */
(function(){
  var uid=0;
  function build(sel){
    if(sel.multiple || sel.dataset.cselect === 'off' || sel.closest('.cselect')) return;
    if(sel.dataset.cselectDone) return;
    sel.dataset.cselectDone='1';
    uid++;
    var wrap=document.createElement('div');
    wrap.className='cselect';
    if(sel.className) wrap.className+=' cselect--'+sel.className.trim().split(/\s+/)[0];
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add('cselect__native');

    var btn=document.createElement('button');
    btn.type='button';
    btn.className='cselect__btn';
    btn.setAttribute('aria-haspopup','listbox');
    btn.setAttribute('aria-expanded','false');
    var lbl=sel.getAttribute('aria-label')||'';
    if(lbl) btn.setAttribute('aria-label', lbl);
    btn.innerHTML='<span class="cselect__val"></span><svg class="cselect__chev" viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

    var panel=document.createElement('div');
    panel.className='cselect__panel';
    panel.setAttribute('role','listbox');
    panel.id='cselect-panel-'+uid;
    panel.hidden=true;
    btn.setAttribute('aria-controls', panel.id);

    wrap.appendChild(btn);
    wrap.appendChild(panel);

    function render(){
      panel.innerHTML='';
      Array.prototype.forEach.call(sel.options, function(o,i){
        var it=document.createElement('div');
        it.className='cselect__opt';
        it.setAttribute('role','option');
        it.dataset.i=String(i);
        it.textContent=o.textContent;
        if(o.disabled){ it.setAttribute('aria-disabled','true'); it.classList.add('is-disabled'); }
        if(i===sel.selectedIndex){ it.setAttribute('aria-selected','true'); it.classList.add('is-on'); }
        else it.setAttribute('aria-selected','false');
        panel.appendChild(it);
      });
      var cur=sel.options[sel.selectedIndex];
      btn.querySelector('.cselect__val').textContent = cur ? cur.textContent : '';
    }

    /* CM_CSELECT_PORTAL — the panel is moved to <body> while open.
       The header search form has overflow:hidden (clips it) and both the form
       and the header use backdrop-filter, which creates a containing block so
       even position:fixed stays trapped. Portalling is the only reliable escape. */
    function place(){
      var r=btn.getBoundingClientRect();
      var vw=document.documentElement.clientWidth;
      var vh=window.innerHeight;
      panel.style.minWidth=Math.max(r.width,220)+'px';
      var pw=panel.offsetWidth;
      var left=r.left;
      if(left+pw > vw-8) left=Math.max(8, r.right-pw);
      panel.style.left=Math.round(left)+'px';
      var below=vh-r.bottom, ph=panel.offsetHeight;
      if(below < ph+12 && r.top > below){
        panel.style.top=Math.round(r.top-ph-6)+'px';
        panel.classList.add('is-up');
      }else{
        panel.style.top=Math.round(r.bottom+6)+'px';
        panel.classList.remove('is-up');
        panel.style.maxHeight=Math.max(160, Math.min(260, below-16))+'px';
      }
    }
    function open(){
      if(!panel.hidden) return;
      closeAll();
      render();
      document.body.appendChild(panel);
      panel.classList.add('cselect__panel--portal');
      panel.hidden=false;
      btn.setAttribute('aria-expanded','true');
      wrap.classList.add('is-open');
      place();
      window.addEventListener('scroll', place, true);
      window.addEventListener('resize', place);
      var on=panel.querySelector('.is-on');
      if(on) on.scrollIntoView({block:'nearest'});
    }
    function close(){
      if(panel.hidden) return;
      panel.hidden=true;
      btn.setAttribute('aria-expanded','false');
      wrap.classList.remove('is-open','is-up');
      panel.classList.remove('cselect__panel--portal','is-up');
      panel.style.cssText='';
      wrap.appendChild(panel);
      window.removeEventListener('scroll', place, true);
      window.removeEventListener('resize', place);
    }
    function pick(i){
      if(i<0||i>=sel.options.length) return;
      if(sel.options[i].disabled) return;
      if(sel.selectedIndex!==i){
        sel.selectedIndex=i;
        sel.dispatchEvent(new Event('input',{bubbles:true}));
        sel.dispatchEvent(new Event('change',{bubbles:true}));
      }
      render(); close(); btn.focus();
    }

    btn.addEventListener('click', function(e){ e.preventDefault(); panel.hidden?open():close(); });
    panel.addEventListener('click', function(e){
      var it=e.target.closest('.cselect__opt');
      if(!it||it.classList.contains('is-disabled')) return;
      pick(parseInt(it.dataset.i,10));
    });

    var typed='', typedT=null;
    btn.addEventListener('keydown', function(e){
      var k=e.key;
      if(k==='ArrowDown'||k==='ArrowUp'||k==='Enter'||k===' '){
        e.preventDefault();
        if(panel.hidden){ open(); return; }
      }
      if(panel.hidden){
        if(k==='ArrowDown'){ pick(sel.selectedIndex+1); }
        else if(k==='ArrowUp'){ pick(sel.selectedIndex-1); }
        return;
      }
      var opts=Array.prototype.slice.call(panel.children);
      var act=panel.querySelector('.is-active')||panel.querySelector('.is-on');
      var ai=act?opts.indexOf(act):-1;
      function mark(n){
        n=Math.max(0,Math.min(opts.length-1,n));
        opts.forEach(function(o){o.classList.remove('is-active');});
        opts[n].classList.add('is-active');
        opts[n].scrollIntoView({block:'nearest'});
      }
      if(k==='ArrowDown'){ e.preventDefault(); mark(ai+1); }
      else if(k==='ArrowUp'){ e.preventDefault(); mark(ai-1); }
      else if(k==='Home'){ e.preventDefault(); mark(0); }
      else if(k==='End'){ e.preventDefault(); mark(opts.length-1); }
      else if(k==='Enter'||k===' '){ e.preventDefault(); if(ai>-1) pick(ai); }
      else if(k==='Escape'){ e.preventDefault(); close(); }
      else if(k==='Tab'){ close(); }
      else if(k.length===1){
        clearTimeout(typedT); typed+=k.toLowerCase();
        typedT=setTimeout(function(){typed='';},600);
        for(var i=0;i<opts.length;i++){
          if(opts[i].textContent.trim().toLowerCase().indexOf(typed)===0){ mark(i); break; }
        }
      }
    });

    sel.addEventListener('change', render);
    wrap.__cselectClose=close;
    render();
  }

  function closeAll(except){
    document.querySelectorAll('.cselect.is-open').forEach(function(w){
      if(w!==except && w.__cselectClose) w.__cselectClose();
    });
  }

  document.addEventListener('click', function(e){
    if(!e.target.closest('.cselect') && !e.target.closest('.cselect__panel')) closeAll();
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeAll(); });
  window.addEventListener('resize', function(){ closeAll(); });

  function scan(root){
    (root||document).querySelectorAll('select').forEach(build);
  }
  window.cmCSelectScan = scan;

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){scan();});
  else scan();

  // catch selects added later (variant swaps, filter reloads)
  if(window.MutationObserver){
    new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        var added=muts[i].addedNodes;
        for(var j=0;j<added.length;j++){
          var n=added[j];
          if(n.nodeType!==1) continue;
          if(n.tagName==='SELECT') build(n);
          else if(n.querySelectorAll) n.querySelectorAll('select').forEach(build);
        }
      }
    }).observe(document.documentElement,{childList:true,subtree:true});
  }
})();


/* ===== CM_VARIANT — keep the buybox honest when the variant changes =====
   The theme rendered product.price and never updated it, so picking a bigger
   size still showed the small size's price. That is a checkout surprise. */
(function(){
  function boot(){
    var box=document.querySelector('[data-buybox]');
    if(!box) return;
    var tag=box.querySelector('[data-variant-json]');
    var sel=document.querySelector('select[name="id"]');
    if(!tag) return;
    var data;
    try{ data=JSON.parse(tag.textContent); }catch(e){ return; }
    if(!data || !data.length) return;

    var elPrice=box.querySelector('[data-v-price]');
    var elOff=box.querySelector('[data-v-off]');
    var elMrp=box.querySelector('[data-v-mrp]');
    var elCompare=box.querySelector('[data-v-compare]');
    var elStock=box.querySelector('[data-v-stock]');
    var addBtn=document.querySelector('form[action*="/cart/add"] [type="submit"]');
    var mainImg=document.querySelector('.pdp__media img, .pdp__main img');

    function apply(id){
      var v=null;
      for(var i=0;i<data.length;i++){ if(String(data[i].id)===String(id)){ v=data[i]; break; } }
      if(!v) v=data[0];

      if(elPrice) elPrice.textContent=v.price;

      if(v.compare){
        if(elCompare) elCompare.textContent=v.compare;
        if(elMrp) elMrp.hidden=false;
        if(elOff){ elOff.textContent='-'+v.off+'%'; elOff.hidden=false; }
      }else{
        if(elMrp) elMrp.hidden=true;
        if(elOff) elOff.hidden=true;
      }

      if(elStock){
        if(!v.available){
          elStock.textContent='Currently unavailable';
          elStock.style.color='#8A8A8A';
        }else if(v.qty>0 && v.qty<3){
          elStock.textContent='Only '+v.qty+' left in stock';
          elStock.style.color='var(--ok)';
        }else{
          elStock.textContent='In stock';
          elStock.style.color='var(--ok)';
        }
      }
      if(addBtn){
        addBtn.disabled=!v.available;
        addBtn.textContent=v.available?'Add to bag':'Sold out';
      }
      if(v.img && mainImg){ mainImg.src=v.img; mainImg.removeAttribute('srcset'); }
    }

    if(sel){
      sel.addEventListener('change', function(){ apply(sel.value); });
      apply(sel.value);
    }else{
      apply(data[0].id);
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


/* ===== CM_YTFACADE — load the YouTube player only when someone presses play ===== */
(function(){
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-yt]');
    if(!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-yt');
    if(!id) return;
    var f = document.createElement('iframe');
    f.className = 'vcard__frame';
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
            '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    f.title = b.getAttribute('aria-label') || 'Video';
    f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    f.setAttribute('allowfullscreen','');
    f.setAttribute('loading','lazy');
    b.replaceWith(f);
  });
})();


/* ===== CM_REVCAROUSEL — reviews carousel =====
   Advances on a timer, pauses on hover, focus, touch and when the tab is
   hidden, and does not autoplay at all if the visitor asked for reduced motion. */
(function(){
  function init(root){
    var track = root.querySelector('[data-rev-track]');
    if(!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if(!slides.length) return;

    var dotsWrap = root.parentElement.querySelector('[data-rev-dots]');
    var prev = root.querySelector('[data-rev-prev]');
    var next = root.querySelector('[data-rev-next]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wantAuto = root.getAttribute('data-autoplay') !== 'false';
    var delay = parseInt(root.getAttribute('data-interval'), 10) || 3000;
    var i = 0, timer = null, paused = false;

    function perView(){
      var w = track.clientWidth;
      var sw = slides[0].getBoundingClientRect().width + 14;
      return Math.max(1, Math.round(w / sw));
    }
    function pages(){ return Math.max(1, slides.length - perView() + 1); }

    function buildDots(){
      if(!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var n = pages();
      if(n < 2){ dotsWrap.hidden = true; return; }
      dotsWrap.hidden = false;
      for(var d=0; d<n; d++){
        (function(d){
          var b = document.createElement('button');
          b.type='button'; b.className='revs__dot'; b.setAttribute('role','tab');
          b.setAttribute('aria-label','Review '+(d+1));
          b.addEventListener('click', function(){ go(d, true); });
          dotsWrap.appendChild(b);
        })(d);
      }
      paint();
    }
    function paint(){
      if(!dotsWrap) return;
      Array.prototype.forEach.call(dotsWrap.children, function(b, d){
        var on = d === i;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    function go(n, user){
      var p = pages();
      i = ((n % p) + p) % p;
      var target = slides[i];
      if(target){
        var left = target.offsetLeft - track.offsetLeft;
        try{ track.scrollTo({left: left, behavior: reduce ? 'auto' : 'smooth'}); }
        catch(e){ track.scrollLeft = left; }
        /* if smooth scrolling never runs (older browsers, background tabs),
           fall back to an instant jump so the carousel cannot stall */
        setTimeout(function(){
          if(Math.abs(track.scrollLeft - left) > 8) track.scrollLeft = left;
        }, 450);
      }
      paint();
      if(user) restart();
    }

    function tick(){ if(!paused) go(i+1); }
    function start(){
      if(!wantAuto || reduce) return;
      if(pages() < 2) return;
      stop();
      timer = setInterval(tick, delay);
    }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    function restart(){ stop(); start(); }

    root.addEventListener('mouseenter', function(){ paused = true; });
    root.addEventListener('mouseleave', function(){ paused = false; });
    root.addEventListener('focusin', function(){ paused = true; });
    root.addEventListener('focusout', function(){ paused = false; });
    track.addEventListener('touchstart', function(){ paused = true; }, {passive:true});
    document.addEventListener('visibilitychange', function(){ paused = document.hidden; });

    if(prev) prev.addEventListener('click', function(){ go(i-1, true); });
    if(next) next.addEventListener('click', function(){ go(i+1, true); });

    var st = null;
    track.addEventListener('scroll', function(){
      clearTimeout(st);
      st = setTimeout(function(){
        var best = 0, bd = Infinity;
        slides.forEach(function(s, n){
          var d = Math.abs((s.offsetLeft - track.offsetLeft) - track.scrollLeft);
          if(d < bd){ bd = d; best = n; }
        });
        var p = pages();
        i = Math.min(best, p - 1);
        paint();
      }, 120);
    }, {passive:true});

    var rt = null;
    window.addEventListener('resize', function(){
      clearTimeout(rt);
      rt = setTimeout(function(){ buildDots(); go(Math.min(i, pages()-1)); restart(); }, 180);
    });

    buildDots();
    start();
  }

  function boot(){ document.querySelectorAll('[data-revs]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
